import { handleActions } from 'redux-actions';
import { reject } from 'lodash';

import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';

import {
  compareAdd,
  CompareAddPayload,
  compareRemove,
  CompareRemovePayload,
  compareRemoveAll,
  stateUpdate,
  State,
} from './action';

const initialState: State = {
  comparablePersonalAccidentQuotes: [],
};

const reducer = handleActions(
  {
    [String(compareAdd)]: (state, { payload }) => {
      const { personalAccidentQuote } = payload as unknown as CompareAddPayload;

      return {
        ...state,
        comparablePersonalAccidentQuotes: [...state.comparablePersonalAccidentQuotes, personalAccidentQuote] as PersonalAccidentQuote[],
      };
    },

    [String(compareRemove)]: (state, { payload }) => {
      const { personalAccidentQuote } = payload as unknown as CompareRemovePayload;

      return {
        ...state,
        comparablePersonalAccidentQuotes: reject(state.comparablePersonalAccidentQuotes, {
          personalAccidentPlanId: personalAccidentQuote.personalAccidentPlanId,
        }),
      };
    },

    [String(compareRemoveAll)]: (state) => {
      return {
        ...state,
        comparablePersonalAccidentQuotes: [],
      };
    },

    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },

  initialState,
);

export default reducer;
